import React, { Component } from "react";
import "antd/dist/antd.css";
import { Route, Switch } from "react-router-dom";
import Login from "./Login";
import Signup from "../../Components/Signup";
import "../../Stylesheet/carrier.scss";
import { Carousel } from "antd";
import { Row, Col } from "antd";
class UserAccess extends Component {
  render() {
    return (
      <div className="useraccess">
        <Row>
          <Col xs={0} sm={0} md={0} lg={12} className="HomeSilder">
            <Carousel autoplay></Carousel>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} className="homeSection">
            {/* <div className="footer">
              <p style={{ marginBottom: "0px" }}>
                Already have an Account?{" "}
                <Link to="/login" className="Loginclick">
                  Click Here to Login
                </Link>
              </p>
            </div> */}
            <Switch>
              <Route path="/carrier_login/Signup" component={Signup}></Route>
              <Route path="/" component={Login}></Route>
            </Switch>
          </Col>
        </Row>
      </div>
    );
  }
}
export default UserAccess;
